import React from 'react';
import {translate} from 'react-i18next';
import PhotoThumbnailView from './PhotoThumbnailView';

class UserPhotoLibrary extends React.PureComponent {

    constructor(props) {

        super(props);

        this.handlePhotoViewOpen = this.handlePhotoViewOpen.bind(this);
    }

    handlePhotoViewOpen(photo) {

        if (this.props.onPhotoViewOpen)
            this.props.onPhotoViewOpen(photo);
    }

    render() {

        return (

            <div className="user-photo-library d-flex flex-wrap">
                {this.props.photos.map(photo => (

                    <PhotoThumbnailView key={photo.id} photo={photo} showControls={true} className="m-1" onFullScreen={() => this.handlePhotoViewOpen(photo)}/>
                ))}
            </div>
        );
    }
}

export default translate()(UserPhotoLibrary);



// WEBPACK FOOTER //
// ./src/components/UserPhotoLibrary.js